import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css';
import App from './App';

// Cleanup legacy local storage keys from previous templates/boilerplates
try {
  if (localStorage.getItem('base44_user')) {
    localStorage.removeItem('base44_user');
  }
} catch (e) {
  console.error("Local storage cleanup failed", e);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
